<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MX931 MFP">
     MX931 MFP
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_is" title="&Ouml;ryggisuppl&yacute;singar">
     &Ouml;ryggisuppl&yacute;singar
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Tilkynningar">
      Tilkynningar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Yfirl&yacute;singar um v&ouml;runa">
      Yfirl&yacute;singar um v&ouml;runa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_is" title="Fr&aelig;&eth;ast um prentarann">
     Fr&aelig;&eth;ast um prentarann
    </a>
   </p>
   <div id="divd0e170">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_is" title="Finna uppl&yacute;singar um prentarann">
      Finna uppl&yacute;singar um prentarann
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_is" title="Finna ra&eth;n&uacute;meri&eth; &aacute; prentaranum">
      Finna ra&eth;n&uacute;meri&eth; &aacute; prentaranum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_is" title="Uppsetningar prentara">
      Uppsetningar prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_is" title="Nota stj&oacute;rnbor&eth; prentara">
      Nota stj&oacute;rnbor&eth; prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_is" title="Skilja st&ouml;&eth;una &aacute; gaumlj&oacute;sinu">
      Skilja st&ouml;&eth;una &aacute; gaumlj&oacute;sinu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e562" title="Val &aacute; papp&iacute;r">
      Val &aacute; papp&iacute;r
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_is" title="Setja upp, setja inn og stilla">
     Setja upp, setja inn og stilla
    </a>
   </p>
   <div id="divd0e3851">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_is" title="Velja sta&eth;setningu fyrir prentarann">
      Velja sta&eth;setningu fyrir prentarann
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_is" title="Tenging &aacute; k&ouml;plum">
      Tenging &aacute; k&ouml;plum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e4039" title="Setja upp og nota forrit &aacute; heimaskj&aacute;num">
      Setja upp og nota forrit &aacute; heimaskj&aacute;num
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e4656" title="Setja upp og nota eiginleika a&eth;gengis">
      Setja upp og nota eiginleika a&eth;gengis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e4959" title="Setja upp prentarann til a&eth; senda fax">
      Setja upp prentarann til a&eth; senda fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_is" title="Setja upp SMTP stillingar t&ouml;lvup&oacute;sts">
      Setja upp SMTP stillingar t&ouml;lvup&oacute;sts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#d0e6754" title="Setja &iacute; papp&iacute;r og s&eacute;rstaka mi&eth;la">
      Setja &iacute; papp&iacute;r og s&eacute;rstaka mi&eth;la
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7149" title="Setja upp og uppf&aelig;ra hugb&uacute;na&eth;, prentrekla og fastb&uacute;na&eth;">
      Setja upp og uppf&aelig;ra hugb&uacute;na&eth;, prentrekla og fastb&uacute;na&eth;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-envelope-tray-topic.html#d0e7431" title="Setja upp valkosti v&eacute;lb&uacute;na&eth;ar">
      Setja upp valkosti v&eacute;lb&uacute;na&eth;ar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="networking-intro-topic.html#d0e8103" title="Nettenging">
      Nettenging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_is" title="Setja upp prentun &aacute; ra&eth;tengi (a&eth;eins Windows)">
      Setja upp prentun &aacute; ra&eth;tengi (a&eth;eins Windows)
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_is" title="Gera prentarann &ouml;ruggan">
     Gera prentarann &ouml;ruggan
    </a>
   </p>
   <div id="divd0e8500">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_is" title="Finna &ouml;ryggistengi">
      Finna &ouml;ryggistengi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_is" title="Ey&eth;a minni prentara">
      Ey&eth;a minni prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_is" title="Ey&eth;a af geymsludrifi prentara">
      Ey&eth;a af geymsludrifi prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_is" title="Endurheimta sj&aacute;lfgefnar verksmi&eth;justillingar">
      Endurheimta sj&aacute;lfgefnar verksmi&eth;justillingar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_is" title="Yfirl&yacute;sing var&eth;andi &oacute;st&ouml;&eth;ugleika">
      Yfirl&yacute;sing var&eth;andi &oacute;st&ouml;&eth;ugleika
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_is" title="Prenta">
     Prenta
    </a>
   </p>
   <div id="divd0e8693">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_is" title="Prentun fr&aacute; t&ouml;lvu">
      Prentun fr&aacute; t&ouml;lvu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e8719" title="Prentun fr&aacute; fart&aelig;ki">
      Prentun fr&aacute; fart&aelig;ki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_is" title="Prentun af minniskorti">
      Prentun af minniskorti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_is" title="Studd minniskort og skr&aacute;arger&eth;ir">
      Studd minniskort og skr&aacute;arger&eth;ir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_is" title="Setja upp tr&uacute;na&eth;arverk">
      Setja upp tr&uacute;na&eth;arverk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_is" title="Prentun &aacute; tr&uacute;na&eth;arm&aacute;lum og &ouml;&eth;rum verndu&eth;um verkum">
      Prentun &aacute; tr&uacute;na&eth;arm&aacute;lum og &ouml;&eth;rum verndu&eth;um verkum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_is" title="Prenta lista yfir s&yacute;nishorn leturger&eth;a">
      Prenta lista yfir s&yacute;nishorn leturger&eth;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_is" title="Prenta lista skr&aacute;asafns">
      Prenta lista skr&aacute;asafns
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_is" title="Setja a&eth;skilna&eth;ars&iacute;&eth;ur &aacute; milli afrita">
      Setja a&eth;skilna&eth;ars&iacute;&eth;ur &aacute; milli afrita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-printed-sheets-topic.html#stapling-printed-sheets_is" title="Hefta prentu&eth; bl&ouml;&eth;">
      Hefta prentu&eth; bl&ouml;&eth;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_is" title="Gata prentu&eth; bl&ouml;&eth;">
      Gata prentu&eth; bl&ouml;&eth;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_is" title="Nota hli&eth;runarst&ouml;flun &iacute; prentu&eth;um bl&ouml;&eth;um">
      Nota hli&eth;runarst&ouml;flun &iacute; prentu&eth;um bl&ouml;&eth;um
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_is" title="H&aelig;tta vi&eth; verk &iacute; prentun">
      H&aelig;tta vi&eth; verk &iacute; prentun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_is" title="Stilla svertustig prentdufts">
      Stilla svertustig prentdufts
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying-chapter.html#copying-chapter_is" title="Afritun">
     Afritun
    </a>
   </p>
   <div id="divd0e9484">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_is" title="Nota sj&aacute;lfvirkan matara skjala (ADF) og">
      Nota sj&aacute;lfvirkan matara skjala (ADF) og
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_is" title="Taka afrit">
      Taka afrit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_is" title="Afritun &aacute; myndum">
      Afritun &aacute; myndum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_is" title="Afritun &aacute; br&eacute;fhaus">
      Afritun &aacute; br&eacute;fhaus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_is" title="Afritun &aacute; b&aacute;&eth;ar hli&eth;ar &aacute; papp&iacute;rnum">
      Afritun &aacute; b&aacute;&eth;ar hli&eth;ar &aacute; papp&iacute;rnum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_is" title="Minnka e&eth;a st&aelig;kka afrit">
      Minnka e&eth;a st&aelig;kka afrit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_is" title="Samra&eth;a afritum">
      Samra&eth;a afritum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_is" title="Setja a&eth;skilna&eth;ars&iacute;&eth;ur &aacute; milli afrita">
      Setja a&eth;skilna&eth;ars&iacute;&eth;ur &aacute; milli afrita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_is" title="Afrita margar s&iacute;&eth;ur &aacute; eina &ouml;rk">
      Afrita margar s&iacute;&eth;ur &aacute; eina &ouml;rk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_is" title="Afrita kort">
      Afrita kort
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-copies-topic.html#stapling-copies_is" title="Hefta afrit">
      Hefta afrit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-copies-topic.html#punching-holes-copies_is" title="Gata afrit">
      Gata afrit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-copies-topic.html#using-offset-stacking-copies_is" title="Nota hli&eth;runarst&ouml;flun &iacute; afritum">
      Nota hli&eth;runarst&ouml;flun &iacute; afritum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_is" title="B&uacute;a til fl&yacute;tiv&iacute;si afritunar">
      B&uacute;a til fl&yacute;tiv&iacute;si afritunar
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="e-mailing-chapter.html#e-mailing-chapter_is" title="T&ouml;lvup&oacute;stur">
     T&ouml;lvup&oacute;stur
    </a>
   </p>
   <div id="divd0e9863">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_is" title="Nota sj&aacute;lfvirkan matara skjala (ADF) og">
      Nota sj&aacute;lfvirkan matara skjala (ADF) og
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_is" title="Senda t&ouml;lvup&oacute;st">
      Senda t&ouml;lvup&oacute;st
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_is" title="B&uacute;a til fl&yacute;tiv&iacute;si fyrir t&ouml;lvup&oacute;st">
      B&uacute;a til fl&yacute;tiv&iacute;si fyrir t&ouml;lvup&oacute;st
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faxing-chapter.html#faxing-chapter_is" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e9957">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_is" title="Nota sj&aacute;lfvirkan matara skjala (ADF) og">
      Nota sj&aacute;lfvirkan matara skjala (ADF) og
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_is" title="Senda fax">
      Senda fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_is" title="Skipuleggja fax">
      Skipuleggja fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_is" title="B&uacute;a til fl&yacute;tiv&iacute;si fyrir &aacute;kv&ouml;r&eth;unarsta&eth; &aacute; faxi">
      B&uacute;a til fl&yacute;tiv&iacute;si fyrir &aacute;kv&ouml;r&eth;unarsta&eth; &aacute; faxi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_is" title="Breyta upplausn &iacute; faxi">
      Breyta upplausn &iacute; faxi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_is" title="Stilla svertustig &aacute; faxi">
      Stilla svertustig &aacute; faxi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_is" title="Prenta atvikaskr&aacute; fyrir fax">
      Prenta atvikaskr&aacute; fyrir fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_is" title="Loka &aacute; ruslf&ouml;x">
      Loka &aacute; ruslf&ouml;x
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_is" title="Geyma f&ouml;x">
      Geyma f&ouml;x
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_is" title="Framsenda fax">
      Framsenda fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="ftp-chapter.html#ftp-chapter_is" title="Sk&ouml;nnun">
     Sk&ouml;nnun
    </a>
   </p>
   <div id="divd0e10321">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_is" title="Nota sj&aacute;lfvirkan matara skjala (ADF) og">
      Nota sj&aacute;lfvirkan matara skjala (ADF) og
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_is" title="Skanna til t&ouml;lvu">
      Skanna til t&ouml;lvu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_is" title="Skanna til FTP-mi&eth;lara">
      Skanna til FTP-mi&eth;lara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_is" title="B&uacute;a til FTP-fl&yacute;tiv&iacute;si">
      B&uacute;a til FTP-fl&yacute;tiv&iacute;si
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_is" title="Skanna &iacute; m&ouml;ppu &aacute; netinu">
      Skanna &iacute; m&ouml;ppu &aacute; netinu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_is" title="B&uacute;a til fl&yacute;tiv&iacute;si fyrir m&ouml;ppu netkerfis">
      B&uacute;a til fl&yacute;tiv&iacute;si fyrir m&ouml;ppu netkerfis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_is" title="Skanna til minniskorts">
      Skanna til minniskorts
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="use-printer-menus-chapter.html#use-printer-menus-chapter_is" title="Nota valmyndir prentarans">
     Nota valmyndir prentarans
    </a>
   </p>
   <div id="divd0e10623">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_is" title="Yfirlit valmynda">
      Yfirlit valmynda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e10986" title="T&aelig;ki">
      T&aelig;ki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e13274" title="Prenta">
      Prenta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e14542" title="Papp&iacute;r">
      Papp&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e14911" title="Afritun">
      Afritun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e15500" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e17906" title="T&ouml;lvup&oacute;stur">
      T&ouml;lvup&oacute;stur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e18956" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e19634" title="USB-drif">
      USB-drif
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e20479" title="Netkerfi/tengi">
      Netkerfi/tengi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e22670" title="Sk&yacute;ja&thorn;j&oacute;nustur">
      Sk&yacute;ja&thorn;j&oacute;nustur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e22727" title="&Ouml;ryggi">
      &Ouml;ryggi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e23916" title="Sk&yacute;rslur">
      Sk&yacute;rslur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_is" title="Bilanaleit">
      Bilanaleit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_is" title="Prentar Stillingars&iacute;&eth;u valmyndar">
      Prentar Stillingars&iacute;&eth;u valmyndar
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_is" title="Vi&eth;hald &aacute; prentaranum">
     Vi&eth;hald &aacute; prentaranum
    </a>
   </p>
   <div id="divd0e24256">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_is" title="Athugun &aacute; st&ouml;&eth;unni &aacute; hlutum og rekstrarv&ouml;rum">
      Athugun &aacute; st&ouml;&eth;unni &aacute; hlutum og rekstrarv&ouml;rum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_is" title="Stilla tilkynningar var&eth;andi rekstrarv&ouml;ru">
      Stilla tilkynningar var&eth;andi rekstrarv&ouml;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_is" title="Setja upp vi&eth;varanir t&ouml;lvup&oacute;sts">
      Setja upp vi&eth;varanir t&ouml;lvup&oacute;sts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_is" title="Sko&eth;a sk&yacute;rslur">
      Sko&eth;a sk&yacute;rslur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-supplies-group_is" title="P&ouml;ntun &aacute; hlutum og rekstrarv&ouml;rum">
      P&ouml;ntun &aacute; hlutum og rekstrarv&ouml;rum
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e24457" title="Skipta um hluti og rekstrarv&ouml;rur">
      Skipta um hluti og rekstrarv&ouml;rur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e25002" title="Hreinsun &aacute; hlutum prentarans">
      Hreinsun &aacute; hlutum prentarans
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e25255" title="Spara orku og papp&iacute;r">
      Spara orku og papp&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_is" title="Prentarinn f&aelig;r&eth;ur &aacute; a&eth;ra sta&eth;setningu">
      Prentarinn f&aelig;r&eth;ur &aacute; a&eth;ra sta&eth;setningu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_is" title="Flutningur &aacute; prentaranum">
      Flutningur &aacute; prentaranum
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_is" title="Leysa vandam&aacute;l">
     Leysa vandam&aacute;l
    </a>
   </p>
   <div id="divd0e25409">
    <p class="toc-2-style">
     <a href="print-quality-problems-picker-topic.html#print-quality-problems-picker_is" title="Vandam&aacute;l var&eth;andi prentg&aelig;&eth;i">
      Vandam&aacute;l var&eth;andi prentg&aelig;&eth;i
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_is" title="Villuk&oacute;&eth;ar prentara">
      Villuk&oacute;&eth;ar prentara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e26363" title="Vandam&aacute;l vi&eth; prentun">
      Vandam&aacute;l vi&eth; prentun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_is" title="Prentarinn svarar ekki">
      Prentarinn svarar ekki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_is" title="Get ekki lesi&eth; minniskort">
      Get ekki lesi&eth; minniskort
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_is" title="Virkja USB-tengi&eth;">
      Virkja USB-tengi&eth;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#d0e28928" title="Losa um fl&aelig;kjur">
      Losa um fl&aelig;kjur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e29438" title="Vandam&aacute;l vi&eth; nettengingu">
      Vandam&aacute;l vi&eth; nettengingu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e29666" title="Vandam&aacute;l var&eth;andi valkosti v&eacute;lb&uacute;na&eth;ar">
      Vandam&aacute;l var&eth;andi valkosti v&eacute;lb&uacute;na&eth;ar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e29792" title="Vandam&aacute;l var&eth;andi rekstarv&ouml;rur">
      Vandam&aacute;l var&eth;andi rekstarv&ouml;rur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e29897" title="Vandam&aacute;l vi&eth; m&ouml;tun papp&iacute;rs">
      Vandam&aacute;l vi&eth; m&ouml;tun papp&iacute;rs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e30263" title="Vandam&aacute;l vi&eth; sendingu t&ouml;lvup&oacute;sts">
      Vandam&aacute;l vi&eth; sendingu t&ouml;lvup&oacute;sts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e30357" title="Vandam&aacute;l vi&eth; faxsendingu">
      Vandam&aacute;l vi&eth; faxsendingu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e31002" title="Vandam&aacute;l vi&eth; sk&ouml;nnun">
      Vandam&aacute;l vi&eth; sk&ouml;nnun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_is" title="Hafa samband vi&eth; stu&eth;ning vi&eth;skiptavina">
      Hafa samband vi&eth; stu&eth;ning vi&eth;skiptavina
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_is" title="Endurvinnsla og f&ouml;rgun">
     Endurvinnsla og f&ouml;rgun
    </a>
   </p>
   <div id="divd0e31798">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_is" title="Endurn&yacute;ting &aacute; v&ouml;rum Lexmark">
      Endurn&yacute;ting &aacute; v&ouml;rum Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_is" title="Endurvinnsla Lexmark umb&uacute;&eth;a">
      Endurvinnsla Lexmark umb&uacute;&eth;a
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_is" title="Tilkynningar">
     Tilkynningar
    </a>
   </p>
   <div id="divd0e31833">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31836" title="V&ouml;ruuppl&yacute;singar">
      V&ouml;ruuppl&yacute;singar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31853" title="Tilkynning var&eth;andi &uacute;tg&aacute;fu">
      Tilkynning var&eth;andi &uacute;tg&aacute;fu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_is" title="V&ouml;rumerki">
      V&ouml;rumerki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_is" title="Tilkynningar var&eth;andi leyfism&aacute;l">
      Tilkynningar var&eth;andi leyfism&aacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_is" title="Stig h&aacute;va&eth;amengunar">
      Stig h&aacute;va&eth;amengunar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_is" title="Tilskipun vegna &uacute;rgangs fr&aacute; raf- og rafeindab&uacute;na&eth;i (WEEE)">
      Tilskipun vegna &uacute;rgangs fr&aacute; raf- og rafeindab&uacute;na&eth;i (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31958" title="Lit&iacute;um-&iacute;on endurhla&eth;anleg rafhla&eth;a">
      Lit&iacute;um-&iacute;on endurhla&eth;anleg rafhla&eth;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_is" title="Regluger&eth; (ESB) 2023/1542">
      Regluger&eth; (ESB) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31996" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_is" title="F&ouml;rgun &aacute; v&ouml;runni">
      F&ouml;rgun &aacute; v&ouml;runni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_is" title="Skil &aacute; Lexmark-hylkjum til endurnota e&eth;a endurn&yacute;tingar">
      Skil &aacute; Lexmark-hylkjum til endurnota e&eth;a endurn&yacute;tingar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_is" title="Tilkynning vegna st&ouml;&eth;urafmagns">
      Tilkynning vegna st&ouml;&eth;urafmagns
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_is" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_is" title="Uppl&yacute;singar um hitastig">
      Uppl&yacute;singar um hitastig
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_is" title="Orkunotkun">
      Orkunotkun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_is" title="Regluger&eth;atilkynningar um endab&uacute;na&eth; fjarskipta">
      Regluger&eth;atilkynningar um endab&uacute;na&eth; fjarskipta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_is" title="Samr&aelig;mi vi&eth; tilskipanir Evr&oacute;pusambandsins (EB)">
      Samr&aelig;mi vi&eth; tilskipanir Evr&oacute;pusambandsins (EB)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_is" title="Tilkynning um &uacute;tvarpstruflanir">
      Tilkynning um &uacute;tvarpstruflanir
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue